import { Box } from '@/generated/model/box'
import { ProgramSettings } from '@/generated/model/programSettings'

export class BoxDef {
  // length
  width: number = 0
  // width
  height: number = 0
  // height
  actualHeight: number = 0
  widthMargin: number = 0
  heightMargin: number = 0
  labelPos: string = ''
}

export function fullWidth (boxDef: BoxDef): number {
  return boxDef.width + boxDef.widthMargin * 2
}

export function fullHeight (boxDef: BoxDef): number {
  return boxDef.height + boxDef.heightMargin * 2
}

export function getBoxDef (box: Box, programSettings: ProgramSettings): BoxDef {
  // graphic box properties
  const boxDef = new BoxDef()
  boxDef.labelPos = programSettings.labelPosition!
  boxDef.width = programSettings.boxOrientationOnConveyor ===
  ProgramSettings.BoxOrientationOnConveyorEnum.SHORT_SIDE_LEADING ? box.length! : box.width!
  boxDef.height = programSettings.boxOrientationOnConveyor ===
  ProgramSettings.BoxOrientationOnConveyorEnum.SHORT_SIDE_LEADING ? box.width! : box.length!
  boxDef.actualHeight = box.height!
  boxDef.widthMargin = (programSettings.boxOrientationOnConveyor ===
  ProgramSettings.BoxOrientationOnConveyorEnum.SHORT_SIDE_LEADING ? box.lengthMargin : box.widthMargin) || 0
  boxDef.heightMargin = (programSettings.boxOrientationOnConveyor ===
  ProgramSettings.BoxOrientationOnConveyorEnum.SHORT_SIDE_LEADING ? box.widthMargin : box.lengthMargin) || 0
  return boxDef
}
